"use client";

import { ControlButtons } from "~/app/(private)/words/Controls";
import { Furigana } from "~/components/common/Furigana";
import { CardHeader, CardTitle } from "~/components/ui/card";
import { cn } from "~/lib/utils";
import { type SelectLemma } from "~/server/db/lemmas/schema";
import { type SelectLexeme } from "~/server/db/lexemes/schema";
import { type SelectTranscript } from "~/server/db/transcripts/schema";
import { JLPT_TEXT_WEIGHTS } from "~/server/db/videos/constants";

export default function WordCardHeader({
  lexeme,
  lemma,
  transcript,
  variant = "inline",
  isMobile = false,
  reverseControls = false,
}: {
  lexeme?: SelectLexeme | null;
  lemma: SelectLemma;
  transcript?: SelectTranscript;
  variant?: "inline" | "drawer";
  isMobile: boolean;
  reverseControls?: boolean;
}) {
  const { text, textFurigana } = lexeme ?? {
    text: lemma.text,
    textFurigana: lemma.textFurigana,
  };
  const { id: lemmaId, jlptLevel } = lemma;

  const showControls = variant === "drawer" || !isMobile;
  const useHoverBehavior = variant === "inline" && !isMobile;

  return (
    <CardHeader
      className={cn("mb-4 flex flex-row items-center pb-2", {
        "bg-muted/30": variant === "inline",
      })}
    >
      <div className="grid gap-0.5">
        <CardTitle className="group flex items-center gap-2 text-lg">
          <Furigana rubyContent={textFurigana ?? text} />
        </CardTitle>
      </div>
      <div className="ml-auto flex h-8 items-center gap-1 pb-5">
        {jlptLevel && (
          <div
            className={cn("text-sm", {
              "group-hover:hidden": useHoverBehavior,
            })}
          >
            <span
              className={
                JLPT_TEXT_WEIGHTS[jlptLevel as keyof typeof JLPT_TEXT_WEIGHTS]
              }
            >
              N{jlptLevel}
            </span>
          </div>
        )}
        {showControls && (
          <div
            className={cn("ml-2 items-center gap-1", {
              "hidden group-hover:flex": useHoverBehavior,
              flex: !useHoverBehavior,
            })}
          >
            <ControlButtons
              lemmaId={lemmaId}
              isStandalone={!transcript}
              reverseControls={reverseControls}
              transcript={transcript}
            />
          </div>
        )}
      </div>
    </CardHeader>
  );
}
